import type { CountryConfiguration } from "src/api/configuration/CountryConfiguration";
import type { CountryConfigurationKeyEnum } from "src/api/configuration/CountryConfigurationEnum";
import { useAuth } from "src/hooks/useAuth";

export function useCountryConfiguration<T extends CountryConfigurationKeyEnum>(
    countryConfigurationKey: T
): CountryConfiguration<T> {
    const { countryConfigs = [] } = useAuth();
    const config = countryConfigs.find(
        (conf) => conf.configurationKey === countryConfigurationKey
    ) as CountryConfiguration<T>;

    return config;
}
